// 261005 E1-P1 — chặng ③ Bản địa hoá: mount `AdaptationLocalize` (E1-P3a: bảng tên đã dời sang ②, ③ chỉ còn thẻ tóm tắt).
// AdaptationLocalize tự fetch `GET localize` và CHỈ được mount ở chặng này (mở tab ở chặng khác: 0 request localize).
import React from 'react';
import { Empty } from 'antd';
import AdaptationLocalize from '../../AdaptationLocalize';
import { entityFocusTarget } from '../entityTableView';
import StageFrame from '../StageFrame';
import { pickJobId } from '../jobTracking';
import { optionsDisabledReason } from '../assistant/optionsAction';
import { useStageIntent, useWorkbenchCtx } from '../WorkbenchContext';

const LocalizeStage: React.FC = () => {
  const { storyId, data, refreshAll, goTo, stageState, requestAssistant, busy, workbench } = useWorkbenchCtx();
  const running = workbench?.jobs.running;
  useStageIntent('localize');
  const outline = data.record?.outline ?? null;
  const approved = data.record?.status === 'APPROVED';

  return (
    <StageFrame stage="localize" gate={{ label: 'Bản địa hoá', gate: outline?.reviewGates?.localize }}>
      {approved
        ? <AdaptationLocalize
          storyId={storyId} onChanged={() => { refreshAll(); }} outlineModifiedAt={data.record?.modifiedAt ?? null}
          onOpenEntities={(t) => goTo(entityFocusTarget(t.kind, undefined, t.filter))}
          externalBusy={busy} adoptJobId={pickJobId(running, 'localize', 'notGate')} adoptGateJobId={pickJobId(running, 'localize', 'gate')}
          hasWrittenEpisodes={data.scripts.length > 0}
          onAskAssistant={requestAssistant} askDisabledReason={optionsDisabledReason({ stageLocked: stageState('localize') === 'locked' })}
        />
        : <Empty description="Cần duyệt khung xương trước khi bản địa hoá" />}
    </StageFrame>
  );
};

export default LocalizeStage;
